import React from "react";
import {getVideogamesID, resetID} from "../../actions/index";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import {Link} from "react-router-dom"
import Loading from "../Loanding/Loanding"
import {deleteVideogames} from "../../actions/index"
import { infoDeDb } from "../../actions/index";
import "./Detail.css";

export default function Detail(){
    const gameDetail= useSelector((state) => state.videogameID)
    const dispatch = useDispatch();
    const {id} = useParams();





    //resetea la info a un array vacio cuando apretas el boton de volver
    function handleResetID(){
     dispatch(resetID())   
    }
  
    useEffect(()=>{
        dispatch(getVideogamesID(id));
        dispatch(infoDeDb());
    },[dispatch,id])

    function handleDelete(id){
        dispatch(deleteVideogames(id))
        dispatch(resetID())
        alert("eliminado correctamente")
    }


    return(
        <div className="containerPrincipal">
            { gameDetail.name?(
            <div className="containerCardInfo">

            <div className="container--buton-eliminar">
               <Link className="link-volver" to="/home"> <button onClick={()=>handleResetID()}>volver</button>
               </Link>
               <button  className="button-eliminar" onClick={()=>handleDelete(id)}>eliminar</button>
            </div>
        
            {/*  imagen del juego */}
            <div className="containerImgDetail">
            <img className="imgDetail" src={gameDetail.background_image} alt="not found" weidth="250px" height="250px"/>
            </div>
            {/*  nombre */}
            <div className="titulo">
            <h1>{gameDetail.name}</h1>
            </div>
            {/* ratin (puntuacion) */}
            <div className="RatingDetail">
            <h2>Rating: {gameDetail.rating}</h2>
            </div>
           
           {/*  info de los generos */}
           <div className="GenerosDetail">
           <p>Generos:</p>
            <div className="container-text">
                {gameDetail.genres?.map((g) => {
                return <div className="genero" key={g.name}>{g.name? g.name:g.genres}</div>;
              })}</div>
           </div>   
              {/* info de las plataformas */}
              <div className="GenerosDetail">
              <p>Plataformas:</p>
              <div className="container-text">
                  {gameDetail.platforms?.map((e) => {  
                return <div className="platform" key={e.name? e.name:e.platforms}>{e.name? e.name:e.platforms}</div>;
              })}</div> 
              </div>  
             {/*  lo que nadie lee, la descripcion */}
            <div className="descriptionDetail" dangerouslySetInnerHTML={{ __html: gameDetail.description}} />
            {/*  fecha o released para los compas */}
            <h3 className="releasedDetail">Fecha de salida: {gameDetail.released}</h3>
            <img
                  className="imgBkg"
                  src={gameDetail.background_image}
                  alt="img not found"
                />
            </div>
                   ):(
                    <div className="containerSinDate">
                        {" "}
                        <Loading />{" "}
                        <Link className="link-volverForDelete" to="/home"> 
                        <button className="buttonVolverDeDelete" onClick={()=>handleResetID()}
                        >VOLVER</button>
                        </Link>
                       {/*  {gameDetail.name?( <p>eliminado</p>):(<p>nada</p>)} */}

                    </div>
                    )
            }

        
        </div>


    )
}